import { render, staticRenderFns } from "./data68.vue?vue&type=template&id=6efb7dcf&scoped=true"
import script from "./data68.vue?vue&type=script&lang=js"
export * from "./data68.vue?vue&type=script&lang=js"
import style1 from "./data68.vue?vue&type=style&index=1&id=6efb7dcf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb7dcf",
  null
  
)

export default component.exports